import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import SalesCatalystLabelField from './SalesCatalystLabelField';
import GenericButton from '../common/GenericButton';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import * as quickReportsActions from '../../actions/quickReportsActions';
import * as crosstabActions from '../../actions/crosstabActions';
import clearBaseIcon from '../../images/insight360/clear-field-icon_190-190-190.png';
import { SALES_CATALYST_MAX_SUB_AUDIENCE, SALES_CATALYST_MAX_COMPETITORS,
  SAVE_SALES_CATALYST_TEMPLATE_LENGTH,
  SALES_CATALYST_API_AUDIENCE } from '../../constants';
import nextIcon from '../../images/run_report_icon_normal.png';
import { isDataPresentInSection } from '../../util/SalesCatalystUtils';
import SalesSectionSearchComponent from '../common/SalesSectionSearchComponent';
import InlineEdit from '../common/InlineEdit/InlineEdit';
import { SAVE_AUDIENCE_TEMPLATE_LENGTH_WARNING } from '../../messages/messages';
import Modal from '../common/Modal/Modal';

const modalWarningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};
const salesSectionComponent = null;
class SalesCatalystInputsTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      brandSelection: {},
      pitchSelection: {},
      brandAudience: [],
      pitchAudience: [],
      brandsubAudience: [{}, {}, {}],
      pitchsubAudience: [{}, {}, {}],
      brandCompetitors: [{}, {}, {}],
      pitchCompetitors: [{}, {}, {}],
      brandMarket: [],
      pitchMarket: [],
      smartSearchStudy: undefined,
      salesCatalystBase: undefined,
      templateUpdate: {
        callBackReference: undefined,
        templateTempVal: undefined,
        saveAsNew: false,
        updateFor: undefined,
      },
      showBrandSearchResult: false,
      showPitchSearchResult: false,
      brandSearchFlag: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.brandAudience && this.props.brandAudience !== nextProps.brandAudience) {
      this.setState({ brandAudience: nextProps.brandAudience });
    }
    if (nextProps.pitchAudience && this.props.pitchAudience !== nextProps.pitchAudience) {
      this.setState({ pitchAudience: nextProps.pitchAudience });
    }
    if (nextProps.brandsubAudience && this.props.brandsubAudience !== nextProps.brandsubAudience) {
      const data = nextProps.brandsubAudience.filter(item => !_.isEmpty(item));
      const len = data.length;
      if (len < SALES_CATALYST_MAX_SUB_AUDIENCE) {
        for (let i = 0; i < SALES_CATALYST_MAX_SUB_AUDIENCE - len; i++) {
          data.push({});
        }
      }
      this.setState({ brandsubAudience: data });
    }
    if (nextProps.pitchsubAudience && this.props.pitchsubAudience !== nextProps.pitchsubAudience) {
      const data = nextProps.pitchsubAudience.filter(item => !_.isEmpty(item));
      const len = data.length;
      if (len < SALES_CATALYST_MAX_SUB_AUDIENCE) {
        for (let i = 0; i < SALES_CATALYST_MAX_SUB_AUDIENCE - len; i++) {
          data.push({});
        }
      }
      this.setState({ pitchsubAudience: data });
    }
    if (nextProps.brandCompetitors && this.props.brandCompetitors !== nextProps.brandCompetitors) {
      const data = nextProps.brandCompetitors.filter(item => !_.isEmpty(item));
      const len = data.length;
      if (len < SALES_CATALYST_MAX_COMPETITORS) {
        for (let i = 0; i < SALES_CATALYST_MAX_COMPETITORS - len; i++) {
          data.push({});
        }
      }
      this.setState({ brandCompetitors: data });
    }
    if (nextProps.pitchCompetitors && this.props.pitchCompetitors !== nextProps.pitchCompetitors) {
      const data = nextProps.pitchCompetitors.filter(item => !_.isEmpty(item));
      const len = data.length;
      if (len < SALES_CATALYST_MAX_COMPETITORS) {
        for (let i = 0; i < SALES_CATALYST_MAX_COMPETITORS - len; i++) {
          data.push({});
        }
      }
      this.setState({ pitchCompetitors: data });
    }
    if (nextProps.brandMarket && this.props.brandMarket !== nextProps.brandMarket) {
      this.setState({ brandMarket: nextProps.brandMarket });
    }
    if (nextProps.pitchMarket && this.props.pitchMarket !== nextProps.pitchMarket) {
      this.setState({ pitchMarket: nextProps.pitchMarket });
    }
    if (nextProps.smartSearchStudy && this.props.smartSearchStudy !== nextProps.smartSearchStudy) {
      this.setState({ smartSearchStudy: nextProps.smartSearchStudy });
    }
    if (this.props.salesCatalystBase !== nextProps.salesCatalystBase) {
      this.setState({ salesCatalystBase: nextProps.salesCatalystBase });
    }
    if (nextProps.brandSelection && this.props.brandSelection !== nextProps.brandSelection) {
      this.setState({ brandSelection: nextProps.brandSelection });
    }
    if (nextProps.pitchSelection && this.props.pitchSelection !== nextProps.pitchSelection) {
      this.setState({ pitchSelection: nextProps.pitchSelection });
    }
  }

  /* getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.BaseDataGrid,
    TargetDataGrid: this.props.TargetDataGrid,
    RecycleElements: this.props.recycleElements,
  }); */

  /* addInputDataPointsSelection = (headerInfo, mainCategory, categorySelection) => {
    this.props.salesCatalystActions.addSalesCatalystDataPoints(
      headerInfo,
      mainCategory,
      categorySelection
    );
  }
  setSalesCatalystBase = baseInfo => {
    this.props.salesCatalystActions.setSalesBase(baseInfo);
  }

  resetSalesCatalyst = () => {
    this.props.salesCatalystActions.resetSalesCatalyst();
    document.getElementById('brand-search-box').value = '';
    document.getElementById('pitch-search-box').value = '';
    this.setState({ showBrandSearchResult: false });
    this.setState({ showPitchSearchResult: false });
  }

  handleClearSalesBaseClick = () => {
    this.props.salesCatalystActions.handleClearSalesBaseClick();
  } */

  resetSalesBrandSummary = () => {
    this.props.salesCatalystActions.resetSalesBrandSummary();
    document.getElementById('brand-search-box').value = '';
    this.setState({ showBrandSearchResult: false });
  };

  resetSalesPitchSummary = () => {
    this.props.salesCatalystActions.resetSalesPitchSummary();
    document.getElementById('pitch-search-box').value = '';
    this.setState({ showPitchSearchResult: false });
  };

  deleteHandler = (e, index, field) => {
    this.props.salesCatalystActions.deleteInputTableItem(field, index);
  }

  audienceTemplateLabelValidate = (value, callback) => {
    // check the label max length equal to 128
    let callBackArg;
    if (value.length > SAVE_SALES_CATALYST_TEMPLATE_LENGTH) {
      callBackArg = false;
    } else {
      callBackArg = true;
    }
    callback(
      callBackArg,
      callBackArg ? '' : SAVE_AUDIENCE_TEMPLATE_LENGTH_WARNING,
    );
  };

  convertToTemplateSaveObj = data => (
    _.reduce(data, (obj, value) => {
      if (value.label) {
        obj.push({ header: value.label, expression: value.expression });
      }
      return obj;
    }, [])
  )

  dataToSelectionObjAndValidate = data => {
    const tempdata = {
      valid: {},
      invalid: [],
    };
    _.forEach(data, (value, key) => {
      tempdata.valid[key] = [];
      _.forEach(value, val => {
        if (val.sampleWgtd !== null) {
          tempdata.valid[key].push({
            label: val.header,
            expression: val.expression,
            sample: val.sampleWgtd.intab,
            weighted: val.sampleWgtd.weighted,
          });
        } else {
          tempdata.invalid.push({
            label: val.header,
            expression: val.expression,
            sample: val.sampleWgtd,
          });
        }
      });
    });
    return tempdata;
  }

  templateSaveSectionData = (audience, subAudiences, competitors, markets) => ({
    audiences: _.isEmpty(audience[0]) ? [] : this.convertToTemplateSaveObj(audience),
    subAudiences: _.isEmpty(subAudiences[0]) ? [] : this.convertToTemplateSaveObj(subAudiences),
    competitors: _.isEmpty(competitors[0]) ? [] : this.convertToTemplateSaveObj(competitors),
    markets: _.isEmpty(markets[0]) ? [] : this.convertToTemplateSaveObj(markets),
  });

  updateTemplateModalClose = () => {
    if (this.state.templateUpdate.callBackReference !== undefined) {
      this.state.templateUpdate.callBackReference(true);
      this.setState({
        templateUpdate: { ...this.state.templateUpdate, callBackReference: undefined },
      });
    }
  }

  updateTemplateBtnAction = type => {
    const section = this.state.templateUpdate.updateFor;
    if (type === 'update' || type === 'saveNew') {
      if (section === 'brand') {
        this.audienceTemplateSaveBrand(type === 'saveNew' ? null : undefined, this.state.templateUpdate.callBackReference);
      } else if (section === 'pitch') {
        this.audienceTemplateSavePitch(type === 'saveNew' ? null : undefined, this.state.templateUpdate.callBackReference);
      }
      this.setState({
        templateUpdate: {
          ...this.state.templateUpdate,
          callBackReference: undefined,
          updateFor: undefined,
        },
      });
    } else if (type === 'saveAsNew') {
      this.setState({
        templateUpdate: {
          ...this.state.templateUpdate,
          saveAsNew: true,
          templateTempVal: undefined,
        },
      });
    }
  }

  audienceTemplateSaveBrand = (value, callbackFn) => {
    this.audienceTemplateBeforeSaveAction(value, callbackFn, 'brand');
  };
  audienceTemplateSavePitch = (value, callbackFn) => {
    this.audienceTemplateBeforeSaveAction(value, callbackFn, 'pitch');
  };

  audienceTemplateBeforeSaveAction = (value, callbackFn, section) => {
    let data = {};
    let sectionData;
    if (section === 'brand') {
      sectionData = this.templateSaveSectionData(
        this.state.brandAudience,
        this.state.brandsubAudience,
        this.state.brandCompetitors,
        this.state.brandMarket,
      );
    } else {
      sectionData = this.templateSaveSectionData(
        this.state.pitchAudience,
        this.state.pitchsubAudience,
        this.state.pitchCompetitors,
        this.state.pitchMarket,
      );
    }
    data = sectionData;
    this.setState({
      templateUpdate: {
        ...this.state.templateUpdate,
        saveAsNew: false,
      },
    }, () => {
      if (this.props.selectedTemplates[section] !== undefined &&
        this.props.selectedTemplates[section].templateId !== undefined) {
        if (value === undefined || value === null) {
          data.templateId = value === null ? null :
            this.props.selectedTemplates[section].templateId;
          data.templateName = this.state.templateUpdate.templateTempVal;
          this.audienceTemplateSaveAction(data, callbackFn);
          this.modalWarning.hide();
          this.setState({
            templateUpdate: {
              ...this.state.templateUpdate,
              callBackReference: undefined,
              templateTempVal: undefined,
              updateFor: undefined,
            },
          });
          return;
        }
        this.setState({
          templateUpdate: {
            ...this.state.templateUpdate,
            callBackReference: callbackFn,
            templateTempVal: value,
            updateFor: section,
          },
        });
        this.modalWarning.show();
      } else {
        data.templateId = null;
        data.templateName = value;
        this.audienceTemplateSaveAction(data, callbackFn);
      }
    });
  }

  audienceTemplateSaveAction = (data, callbackFn) => {
    const saveTemplateParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.pn,
      data,
      type: SALES_CATALYST_API_AUDIENCE,
    };
    this.props.salesCatalystActions.saveSCTemplate(saveTemplateParams).then(response => {
      if (response) {
        callbackFn(true);
      } else {
        callbackFn(false);
      }
    });
  }

  audienceTemplateLoadAction = (section, templateId) => {
    const loadTemplateParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      type: SALES_CATALYST_API_AUDIENCE,
      data: {
        templateId,
        productNo: this.state.smartSearchStudy.pn,
        divisor: this.state.smartSearchStudy.dv,
        weightType: this.state.smartSearchStudy.wt,
      },
    };

    this.props.salesCatalystActions.scLoadTemplate(loadTemplateParams).then(response => {
      const data = this.dataToSelectionObjAndValidate({
        audience: response.audiences,
        subAudience: response.subAudiences,
        competitors: response.competitors,
        market: response.markets,
      });

      if (data.invalid.length > 0) {
        this.props.showValidateStudyPopup(data.invalid, true);
      }
      if (_.find(data.valid, o => o.length > 0) !== undefined) {
        const templateInfo = {
          templateId: response.templateId,
          templateName: response.templateName,
        };
        if (section === 'brand') {
          this.props.salesCatalystActions.updateSelectionsData(data.valid, undefined);
          this.props.salesCatalystActions.updateSelectedTemplateData(templateInfo, section);
        } else if (section === 'pitch') {
          this.props.salesCatalystActions.updateSelectionsData(undefined, data.valid);
          this.props.salesCatalystActions.updateSelectedTemplateData(templateInfo, section);
        }
      }
    });
  }

  isTableSelectionsEmpty = value => {
    if (value === 'brand') {
      return _.isEmpty(this.state.brandSelection[0]) &&
        _.isEmpty(this.state.brandAudience[0]) &&
        _.isEmpty(this.state.brandsubAudience[0]) &&
        _.isEmpty(this.state.brandCompetitors[0]);
    } else if (value === 'pitch') {
      return _.isEmpty(this.state.pitchSelection[0]) &&
        _.isEmpty(this.state.pitchAudience[0]) &&
        _.isEmpty(this.state.pitchsubAudience[0]) &&
        _.isEmpty(this.state.pitchCompetitors[0]);
    }
    return false;
  }

  setShowSearchResult = (flag, side) => {
    if (side === 'brand') {
      this.setState({ showBrandSearchResult: flag });
    } else {
      this.setState({ showPitchSearchResult: flag });
    }
  }

  render() {
    return (
      <div className="row fullWidth table-container">
        <Modal
          title=""
          ref={node => (this.modalWarning = node)}
          dialogStyles={modalWarningStyle}
          afterClose={() => this.updateTemplateModalClose()}
        >
          <div className="text-center">
            <div>
              <p>Would you like to update the existing template or save as a new template?</p>
              {!this.state.templateUpdate.saveAsNew && <div>
                <GenericButton
                  btnStyle="button"
                  name="Update"
                  onBtnClick={() => this.updateTemplateBtnAction('update')}
                />
                <GenericButton
                  btnStyle="button btn-cncl"
                  name="Save As New"
                  onBtnClick={() => this.updateTemplateBtnAction(`${
                    this.props.selectedTemplates[this.state.templateUpdate.updateFor].templateName === this.state.templateUpdate.templateTempVal ? 'saveAsNew' : 'saveNew'
                    }`)}
                />
              </div>}
              {this.state.templateUpdate.saveAsNew && <div>
                <input
                  type="text"
                  ref={node => (this.newTemplateNameFiled = node)}
                  placeholder="Enter New Template Name"
                  className="summary-input-box"
                  onChange={() => this.setState({
                    templateUpdate: {
                      ...this.state.templateUpdate,
                      templateTempVal: this.newTemplateNameFiled.value,
                    },
                  })}
                />
                <div className="margin-top-10">
                  <GenericButton
                    btnStyle="button"
                    name="Save"
                    onBtnClick={() =>
                      (this.state.templateUpdate.templateTempVal !== undefined &&
                        this.state.templateUpdate.templateTempVal.length > 0) ?
                        this.updateTemplateBtnAction('saveNew') : {}
                    }
                  />
                  <GenericButton
                    btnStyle="button btn-cncl"
                    name="Cancel"
                    onBtnClick={() => this.modalWarning.hide()}
                  />
                </div>
              </div>}
            </div>
          </div>
        </Modal>
        {/* <div className="smart-search-editor">
          <SmartSearch
            selectedModule="salescatalyst"
            moduleStudy={this.state.smartSearchStudy}
            getSampleWeighted={
              this.props.quickReportsActions.getSampleWeighted
            }
            fetchKPI={this.props.crosstabActions.fetchKPI}
            removeKPI={this.props.crosstabActions.removeCrossTabKpiInfo}
            gridData={this.getGridData()}
            dataScreen={'salescatalyst'}
            setSalesCatalystBase={this.setSalesCatalystBase}
            addInputDataPointsSelection={this.addInputDataPointsSelection}
            resetSalesCatalyst={this.resetSalesCatalyst}
          />
        </div> */}
        {/* (this.state.salesCatalystBase !== undefined &&
          this.state.salesCatalystBase.length !== 0) && (
            <div className="row fullWidth">
              <div className="large-1 medium-1 small-1 columns">
                <span>&nbsp;</span>
              </div>
              <div className="large-10 medium-10 small-10 columns">
                <span
                  className="base sales-catalyst"
                  id="explorer-label-ellipsis"
                  title={this.state.salesCatalystBase.baseLabel}
                >
                  BASE: {this.state.salesCatalystBase.baseLabel}
                </span>
                <img
                  className="i360_header_icons_img"
                  id="baseRemoveIcon"
                  src={clearBaseIcon}
                  alt="Remove"
                  onClick={() => {
                    this.handleClearSalesBaseClick();
                  }}
                />
              </div>
              <div className="large-1 medium-1 small-1 columns">
                <span>&nbsp;</span>
              </div>
            </div>
          ) */}
        <div className="row table-content">
          <div className="large-6 table-column brand-table">
            <div className="brand-summary-label">BRAND SELECTIONS
              <span className="SalesSectionSearchBar">
                <SalesSectionSearchComponent
                  section="brand"
                  loadAction={this.audienceTemplateLoadAction}
                  showSearchResult={this.state.showBrandSearchResult}
                  setShowSearchResult={this.setShowSearchResult}
                />
              </span>
              <span className="summary-label-reset">
                <GenericButton
                  name=""
                  btnStyle="i360-smart-search-button reset-btn"
                  btnDisabled={!isDataPresentInSection(this.props.brandSelection)}
                  onBtnClick={this.resetSalesBrandSummary}
                />
              </span>
            </div>
            <div className="label-container">
              <span>Audience:</span>
              <SalesCatalystLabelField
                data={this.state.brandAudience.length > 0 ? this.state.brandAudience[0] : []}
                deleteHandler={this.deleteHandler}
                key={'brand-aud'}
                field={'brand-aud'}
                index={0}
                dataList={this.state.brandAudience.length > 0 ? this.state.brandAudience : []}
              />
            </div>
            <div className="label-container">
              <span>Sub-Audience (optional):</span>
              {this.state.brandsubAudience.length > 0 ? this.state.brandsubAudience.map((item, index) => (
                <SalesCatalystLabelField
                  data={item}
                  deleteHandler={this.deleteHandler}
                  key={`brand-subaud${index}`}
                  field={'brand-subaud'}
                  index={index}
                  dataList={this.state.brandsubAudience}
                />
              )) : <SalesCatalystLabelField
                data={[]}
              />}
            </div>
            <div className="label-container">
              <span>Competitors:</span>
              {this.state.brandCompetitors.length > 0 ? this.state.brandCompetitors.map((item, index) => (
                <SalesCatalystLabelField
                  data={item}
                  deleteHandler={this.deleteHandler}
                  key={`brand-compet${index}`}
                  field={'brand-compet'}
                  index={index}
                  dataList={this.state.brandCompetitors}
                />
              )) : <SalesCatalystLabelField
                data={[]}
              />}
            </div>
            <div className="label-container">
              <span>Market:</span>
              <SalesCatalystLabelField
                data={this.state.brandMarket.length > 0 ? this.state.brandMarket[0] : []}
                deleteHandler={this.deleteHandler}
                key={'brand-market'}
                field={'brand-market'}
                index={0}
                dataList={this.state.brandMarket.length > 0 ? this.state.brandMarket : []}
              />
            </div>
            <br />
            <span className="summary-save-label">Save Brand Selection</span>
            <div className="save-input-container">
              <InlineEdit
                textVal={''}
                editBlockWidth="100%"
                updateFn={this.audienceTemplateSaveBrand}
                validateFn={this.audienceTemplateLabelValidate}
                editMode="on"
                placeholder="Save Brand Summary Name"
                editViewClass="summary-input-box"
                disabled={`${this.isTableSelectionsEmpty('brand') ? 'disabled' : ''}`}
              />
            </div>
          </div>
          <div className="large-6 table-column pitch-table">
            <div className="pitch-summary-label">PITCH SELECTIONS
              <span className="SalesSectionSearchBar">
                <SalesSectionSearchComponent
                  section="pitch"
                  loadAction={this.audienceTemplateLoadAction}
                  showSearchResult={this.state.showPitchSearchResult}
                  setShowSearchResult={this.setShowSearchResult}
                /></span>
              <span className="summary-label-reset">
                <GenericButton
                  name=""
                  btnStyle="i360-smart-search-button reset-btn"
                  btnDisabled={!isDataPresentInSection(this.props.pitchSelection)}
                  onBtnClick={this.resetSalesPitchSummary}
                />
              </span>
            </div>
            <div className="label-container">
              <span>Audience:</span>
              <SalesCatalystLabelField
                data={this.state.pitchAudience.length > 0 ? this.state.pitchAudience[0] : []}
                deleteHandler={this.deleteHandler}
                key={'pitch-aud'}
                field={'pitch-aud'}
                index={0}
                dataList={this.state.pitchAudience.length > 0 ? this.state.pitchAudience : []}
              />
            </div>
            <div className="label-container">
              <span>Sub-Audience (optional):</span>
              {this.state.pitchsubAudience.length > 0 ? this.state.pitchsubAudience.map((item, index) => (
                <SalesCatalystLabelField
                  data={item}
                  deleteHandler={this.deleteHandler}
                  key={`pitch-subaud${index}`}
                  field={'pitch-subaud'}
                  index={index}
                  dataList={this.state.pitchsubAudience}
                />
              )) : <SalesCatalystLabelField
                data={[]}
              />}
            </div>
            <div className="label-container">
              <span>Competitors:</span>
              {this.state.pitchCompetitors.length > 0 ? this.state.pitchCompetitors.map((item, index) => (
                <SalesCatalystLabelField
                  data={item}
                  deleteHandler={this.deleteHandler}
                  key={`pitch-compet${index}`}
                  field={'pitch-compet'}
                  index={index}
                  dataList={this.state.pitchCompetitors}
                />
              )) : <SalesCatalystLabelField
                data={[]}
              />}
            </div>
            <div className="label-container">
              <span>Market:</span>
              <SalesCatalystLabelField
                data={this.state.pitchMarket.length > 0 ? this.state.pitchMarket[0] : []}
                deleteHandler={this.deleteHandler}
                key={'pitch-market'}
                field={'pitch-market'}
                index={0}
                dataList={this.state.pitchMarket.length > 0 ? this.state.pitchMarket : []}
              />
            </div>
            <br />
            <span className="summary-save-label">Save Pitch Selection</span>
            <div className="save-input-container">
              <InlineEdit
                textVal={''}
                editBlockWidth="100%"
                updateFn={this.audienceTemplateSavePitch}
                validateFn={this.audienceTemplateLabelValidate}
                editMode="on"
                placeholder="Save Pitch Summary Name"
                editViewClass="summary-input-box"
                disabled={`${this.isTableSelectionsEmpty('pitch') ? 'disabled' : ''}`}
              />
            </div>
          </div>
        </div>
        <div className="analyze-button-content">
          <button className="analyze-btn">Analyze
            <img className="anaylyze-img" role="presentation" src={nextIcon} /></button>
        </div>
      </div >
    );
  }
}

SalesCatalystInputsTable.propTypes = {
  brandContent: PropTypes.shape({}),
  pitchContent: PropTypes.shape({}),
  resetSalesBrandSummary: PropTypes.shape({}),
  resetSalesPitchSummary: PropTypes.shape({}),
  activeAccountId: PropTypes.number,
  quickReportsActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    clearAllReport: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    fetchKPI: PropTypes.func,
  }),
  kpiInfo: PropTypes.shape({}),
  smartSearchStudy: PropTypes.shape({}),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  selectedTemplates: PropTypes.shape({}),
  showValidateStudyPopup: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    kpiInfo: state.crosstab.kpiInfo,
    productNo: state.study.salesCatalystStudy.pn,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesCatalystInputsTable);
